var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BaseListHeader',[_c('div',{staticClass:"flex -mx-3"},[_c('div',{staticClass:"flex-1 px-3"},[_vm._v("Name")]),_c('div',{staticClass:"w-24 px-3 text-right"},[_vm._v("Status")]),_c('div',{staticClass:"w-48 px-3 text-right"},[_vm._v("Subscribed")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }